export const categories = [
    { value: "jumpsuit", label: "Macacão" },
    { value: "dress", label: "Vestido" },
    { value: "blazer", label: "Blazer"},
    { value: "vest" , label: "Colete"},
    { value: "top" , label: "Top"},
    { value: "shirt", label: "Camisa"},
    { value: "pants", label: "Calça"},
    { value: "short", label: "Short"},
    { value: "bermuda", label: "Bermuda"},
];

export const lines = [
    { value: "casual", label: "Casual" },
    { value: "basic", label: "Básica" },
    { value: "premium", label: "Premium" },
];

export const ages = [
    { value: "adult", label: "Adulto" },
    { value: "kid", label: "Criança" },
];

const adultTableSizeFactory = () => [
    {
        size: "PP",
        bust: "86",
        waist: "68",
        hip: "96",
        lenghtSize: "98",
    },
    {
        size: "P",
        bust: "90",
        waist: "72",
        hip: "100",
        lenghtSize: "99",
    },
    {
        size: "M",
        bust: "94",
        waist: "76",
        hip: "104",
        lenghtSize: "100",
    },
    {
        size: "G",
        bust: "98",
        waist: "80",
        hip: "108",
        lenghtSize: "102",
    },
    {
        size: "GG",
        bust: "102",
        waist: "84",
        hip: "112",
        lenghtSize: "104",
    },
    {
        size: "XGG",
        bust: "106",
        waist: "88",
        hip: "116",
        lenghtSize: "106",
    },
];

const kidTableSizeFactory = () => [
    {
        size: "4",
        bust: "58",
        waist: "56",
        hip: "60",
        lenghtSize: "110",
    },
    {
        size: "6",
        bust: "62",
        waist: "58",
        hip: "65",
        lenghtSize: "121",
    },
    {
        size: "8",
        bust: "66",
        waist: "60",
        hip: "70",
        lenghtSize: "133",
    },
    {
        size: "10",
        bust: "70",
        waist: "62",
        hip: "75",
        lenghtSize: "142",
    },
    {
        size: "12",
        bust: "74",
        waist: "64",
        hip: "80",
        lenghtSize: "150",
    }
];

export const tableSizeFactories = {
    adult: adultTableSizeFactory,
    kid: kidTableSizeFactory
}

const kidStockFactory = () => [
    {
        size: "4",
        quantity: 0,
    },
    {
        size: "6",
        quantity: 0,
    },
    {
        size: "8",
        quantity: 0,
    },
    {
        size: "10",
        quantity: 0,
    },
    {
        size: "12",
        quantity: 0,
    }
];

const adultStockFactory = () => [
    {
        size: "PP",
        quantity: 0,
    },
    {
        size: "P",
        quantity: 0,
    },
    {
        size: "M",
        quantity: 0,
    },
    {
        size: "G",
        quantity: 0,
    },
    {
        size: "GG",
        quantity: 0,
    },
    {
        size: "XGG",
        quantity: 0,
    },
];

export const stockFactories = {
    kid: kidStockFactory,
    adult: adultStockFactory
}
